module.exports = __webpack_public_path__ + "static/media/calendar.69780f53.svg";